/* eslint-disable  @typescript-eslint/no-explicit-any */
import { PersistConfig, createMigrate } from 'redux-persist'

import { CartState } from './cart.types'
import { storageDb } from '../../../services/localforage'

const migrations = {
  0: (state: any) => {
    return {
      ...state,
    }
  },

  1: (state: any) => {
    const cart = state.carts
    if (state.carts) {
      const keys = Object.keys(state.carts)
      keys.forEach((key) => {
        cart[key] = {
          ...cart[key],
          offlineCartId: cart[key].offlineCartId ?? cart[key].cartId ?? null,
          onlineCartId: cart[key].onlineCartId ?? null,
        }
        delete cart[key].cartId
      })
    }
    return {
      ...state,
      carts: cart,
      completeOrders: state.completeOrders,
      orders: state.orders,
    }
  },
}

export const cartPersistConfig: PersistConfig<CartState> = {
  key: 'cart',
  storage: storageDb,
  version: 1,
  // serialize: false,
  migrate: createMigrate(migrations),
  blacklist: ['order'],
}
